import { isEmpty } from "lodash";
import { tColumn, tColumnId, tHeaderInstance, tRowInstance } from "src/hooks/table";

export const getHiddenColumnsFromConfig = (config: Partial<Record<tColumnId, boolean>>): tColumnId[] => {
  if (isEmpty(config)) return [];
  let columnId: tColumnId;
  const result: tColumnId[] = [];
  for (columnId in config) {
    const value = config[columnId];
    if (!value) {
      result.push(columnId);
    }
  }
  return result;
};

export const generateCSVFromTableInstance = <T extends unknown>(
  rows: tRowInstance<T>[],
  headers: tHeaderInstance<T>[],
): string => {
  let csv = headers.map((header) => header.header).join(`\t`);
  rows.forEach((row) => {
    let line = "";
    row.cells.forEach((cell, cellIndex) => {
      line = cellIndex === 0 ? `${cell.value}` : `${line}\t${cell.value}`;
    });
    csv = `${csv}\n${line}`;
  }, []);
  return csv;
};

export const checkColumns = <T extends unknown>(columns: tColumn<T>[]): Record<string, boolean> => {
  return Object.fromEntries(columns.filter((column) => !column.alwaysVisible).map((column) => [column.id, true]));
};

export const generateCheckColumns = <T extends unknown>(columns: tColumn<T>[]): Record<tColumnId, boolean> => {
  const kEmptyConfig: Record<tColumnId, boolean> = {};
  columns.forEach((column) => {
    if (!column.alwaysVisible) kEmptyConfig[column.id] = true;
  });
  return kEmptyConfig;
};
